import { configurationService } from '../../services/configuration';
import { Space } from '../../types';

export const default_space: Space = {
  total: { total: 0 },
  versioning: { total: 0 },
  used: { total: 0 },
  publicsharing: {
    enabled: configurationService.isModuleEnabled('PublicSharing'),
  },
  securesync: {
    enabled: configurationService.isModuleEnabled('SecureSync'),
    total: 0,
    folder_count: -1,
    file_count: 0,
    share_request: 0,
    share_request_expired: 0,
  },
  securevault: {
    enabled: configurationService.isModuleEnabled('SecureVault'),
    total: 0,
    folder_count: 0,
    file_count: 0,
    share_request: 0,
    share_request_expired: 0,
  },
  secureinbox: {
    enabled: configurationService.isModuleEnabled('SecureInBox'),
    total: 0,
    new_doc_count: 0,
    doc_count: 0,
    share_request: 0,
    share_request_expired: 0,
  },
  securepassword: {
    enabled: configurationService.isModuleEnabled('SecurePassword'),
    count_pwd: 0,
  },
  no_space_left: false,
};

// Funzioni di utilità per la formattazione
export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const formatToMB = (bytes: number) =>
  (bytes / (1024 * 1024)).toFixed(2) + ' MB';
export const formatToGB = (bytes: number) =>
  (bytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';

export const formatOutput = (total: number = 0) => {
  return {
    bytes: total,
    formatted: formatBytes(total),
    mb: formatToMB(total),
    gb: formatToGB(total),
  };
};
